import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { LicenseENUM, ToolENUM, LicenseInput } from '../../types/license';
import { useLocation } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { sanitizeEmail } from '../../utils/inputSanitizer';

interface CreateLicenseFormProps {
  license: LicenseInput;
  onLicenseChange: (license: LicenseInput) => void;
  disabledFields?: {
    email?: boolean;
    serialNo?: boolean;
  };
}

export const CreateLicenseForm: React.FC<CreateLicenseFormProps> = ({
  license,
  onLicenseChange,
  disabledFields = {}
}) => {
  const location = useLocation();
  const currentModel = location.pathname.includes('michanger') ? ToolENUM.MiChanger : ToolENUM.OneChanger;

  const handleChange = (field: keyof LicenseInput, value: any) => {
    // Apply email sanitization for email field
    if (field === 'email') {
      value = sanitizeEmail(value);
    }

    onLicenseChange({
      ...license,
      [field]: value
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, pt: 2 }}>
        <Box sx={{ display: 'flex' }}>
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            value={license.email}
            onChange={(e) => handleChange('email', e.target.value)}
            disabled={disabledFields.email}
          />
        </Box>
        <Box sx={{ display: 'flex' }}>
          <TextField
            fullWidth
            label="Serial No"
            variant="outlined"
            value={license.serialNo}
            onChange={(e) => handleChange('serialNo', e.target.value)}
            disabled={disabledFields.serialNo}
          />
        </Box>
        <Box sx={{ display: 'flex' }}>
          <FormControl fullWidth>
            <InputLabel>License Type</InputLabel>
            <Select
              value={license.type}
              label="License Type"
              onChange={(e) => handleChange('type', e.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {Object.values(LicenseENUM).map((type: LicenseENUM) => (
                <MenuItem key={type} value={type}>{type}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex' }}></Box>
        {/* <Box sx={{ display: 'flex' }}>
          <DatePicker
            label="Start Date"
            value={license.dateStart ? new Date(license.dateStart) : new Date()}
            onChange={(date) => handleChange('dateStart', date ? date.getTime() : Date.now())}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </Box> */}
        <Box sx={{ display: 'flex' }}>
          <FormControl fullWidth>
            <InputLabel>Duration (Days)</InputLabel>
            <Select
              value={license.durationInDay}
              label="Duration (Days)"
              onChange={(e) => handleChange('durationInDay', Number(e.target.value))}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {[30, 60, 90, 180, 360].map((days) => (
                <MenuItem key={days} value={days}>{days}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex' }}>
          <TextField
            fullWidth
            type="number"
            label="Custom Duration (Days)"
            variant="outlined"
            value={license.durationDayCustom === 0 ? '' : license.durationDayCustom}
            onChange={(e) => handleChange('durationDayCustom', e.target.value === '' ? 0 : parseInt(e.target.value))}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};